import React from "react";
import { TimePicker, Form } from "antd";

export function TimeInput(props) {
  return (
    <Form.Item
      name={props.name}
      label={props.label}
      className={props.className}
      initialValue={props.initialValue}
      rules={[
        {
          required: props.required,
          message: props.errorMessage,
        },
      ]}
    >
      <TimePicker
        format={props.format}
        style={props.style}
        placeholder={props.placeholder}
        use12Hours={props.use12Hours}
        allowClear={props.allowClear}
        autoFocus={props.autoFocus}
        clearIcon={props.clearIcon}
        disabled={props.disabled}
        disabledTime={props.disabledTime}
        hourStep={props.hourStep}
        minuteStep={props.minuteStep}
        status={props.status}
        // suffixIcon={props.suffixIcon}
        onChange={props.onChange}
        onSelect={props.onSelect}
      />
    </Form.Item>
  );
}
